<template>
    <div class="d-flex flex-column" style="min-height: 100%; height: 100%;">

        <header class="sticky-top bg-white border-bottom d-flex" style="min-height: 110px; height: 110px;"
                v-if="wide">
            <div class="my-auto ml-3 pt-2">
                <div class="came">
                    {{ $t('nav.came') }}
                </div>
                <div class="text-muted small mt-n2">{{ $t('nav.acs-cloud') }}</div>
            </div>
            <came-logo class="my-auto" width="48" height="48" fill="#009fe3" />
            <router-link class="stretched-link" to="/" />
        </header>

        <header class="sticky-top bg-white border-bottom d-flex" style="min-height: 110px; height: 110px;"
                v-else>
            <div class="m-auto bg-cameblue p-1" style="border-radius: 100px;">
                <came-logo width="36" height="36" fill="#ffffff" />
            </div>
            <router-link class="stretched-link" to="/" />
        </header>

        <div class="mb-auto overflow-auto mt-3">
            <side-menu-item-acs v-for="(subItem, index) in menuItems"
                                :key="index"
                                :item="subItem"
                                :wide="wide"
                                :depth="0"
                                @expand="subItemExpand"
                                @collapse="subItemCollapse"
                                @widen="subItemWiden"
                                @narrow="subItemNarrow" />
        </div>

        <div class="px-1 py-2 text-center" v-if="wide">
            <light-dark-mode-toggle />
        </div>

        <div class="py-2 d-flex" v-else>
            <div class="bg-light text-center p-2 mx-auto" style="border-radius: 100px; line-height: 0;"
                 role="button" @click="darkMode = !darkMode">
                <b-icon icon="sun" font-scale="1.5" v-if="!darkMode" />
                <b-icon icon="moon" font-scale="1.5" v-if="darkMode" />
            </div>
        </div>

        <div class="border-top btn-group dropup" style="min-height: 60px; height: 60px">
            <button class="btn dropdown-toggle border-0 bg-transparent text-black d-flex w-100" data-toggle="dropdown">
                
                <!--<identicon-image hash-string="CAF64B30E514424" :image-size="42"
                                 :class="['float-left', 'my-auto', 'mr-2', wide ? 'ml-3' : 'ml-0']" 
                                 style="border-radius: 100px; border: 2px solid var(--border);" />-->
                

                <initials-circle :image-size="42" :first-name="user.user.firstName" :surname="user.user.surname" />

                <div v-if="wide" class="small my-auto text-left">
                    <strong>{{ user.user.displayName }}</strong>
                    <br />
                    <span>{{ user.user.email }}</span>
                </div>
            </button>
            <div class="dropdown-menu">
                <router-link class="dropdown-item" to="/account">{{ $t('nav.my-account') }}</router-link>
                <router-link class="dropdown-item" to="/my-client">{{ $t('actions.my') }} {{$t('objects.client')}}</router-link>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" @click="logoutClick" role="button">{{ $t('nav.logout') }}</a>
            </div>
        </div>

   
    </div>
</template>

<script>
    import IdenticonImage from 'common/components/common/identicon-image';
    import InitialsCircle from 'common/components/common/initials-circle';


    import SideMenuItemAcs from './side-menu-item-acs';
    import LightDarkModeToggle from 'common/components/common/light-dark-mode-toggle';
    import favourite from 'common/mixins/favourite';
    import CameLogo from 'common/components/common/came-logo';

    export default {
        components: {
            'identicon-image': IdenticonImage,
            'side-menu-item-acs': SideMenuItemAcs,
            'light-dark-mode-toggle': LightDarkModeToggle,
            'came-logo': CameLogo,
            'initials-circle': InitialsCircle
        },

        props: {
            wide: true,
        },

        emits: [
            'widen', // (menuItem) => menuItem request widen, bubble up to app-acs.vue to handle it
            'narrow', // (menuItem) => menuItem request narrow down, bubble up to app-acs.vue to handle it
        ],

        data: function () {
            return {
                switchableClientsFilter: '',
                switchableClients: [],
                darkMode: false,
                menuItems: [
                    {
                        text: this.$t('nav.dashboard'),
                        icon: 'columns-gap',
                        to: '/dashboard',
                    },
                    //{
                    //    type: 'browsing-client',
                    //    text: null,
                    //    icon: 'person',
                    //    expanded: false,
                    //    menuItems: [],
                    //},

                    {
                        text: this.$t('nav.notifications'),
                        icon: 'clipboard-check',
                        expanded: false,
                        neverHide: true,
                        menuItems: [
                            {
                                text: this.$t('nav.alarms'),
                                icon: 'exclamation-triangle-fill',
                                to: '/notifications/alarms',
                                permissions: ['EVENT_READ']
                            },
                            {
                                text: this.$t('nav.alerts'),
                                icon: 'exclamation-triangle',
                                to: '/notifications/alerts',
                                permissions: ['EVENT_READ']
                            },
                            {
                                text: this.$t('nav.events'),
                                icon: 'lightning-charge',
                                to: '/notifications/alert-trigger',
                                permissions: ['ALERTTRIGGER_READ']
                            },
                            {
                                text: this.$t('nav.client-messages'),
                                icon: 'envelope',
                                to: '/notifications/client-messages',
                                permissions: ['CLIENTMESSAGE_READ']
                            }
                        ],
                    },
                    {
                        text: this.$t('nav.control-panel'),
                        icon: 'gear',
                        expanded: false,
                        menuItems: [
                            {
                                type:"client",
                                text: (this.$auth.user().browsingClient.isEngineer ?  this.$t("nav.site-owners") : this.$t("nav.installers")),
                                icon: 'diagram3',
                                to: '/management/client',
                                permissions: ['CLIENT_READ']
                            },
                            {
                                text: this.$t('nav.areas'),
                                icon: 'building',
                                to: '/administration/areas',
                                permissions: ['AREA_READ']
                            },
                            {
                                text: this.$t('nav.site-plans'),
                                icon: 'pin-map',
                                to: '/administration/site-plans',
                                permissions: ['AREA_READ']
                            },
                            //{
                            //    text: this.$t('nav.groups'),
                            //    icon: 'collection',
                            //    to: '/administration/groups',
                            //    permissions: ['GROUP_READ']
                            //},
                            //{
                            //    text: this.$t('nav.door-groups'),
                            //    icon: 'collection',
                            //    to: '/administration/door-groups',
                            //    permissions: ['DOORGROUP_READ']
                            //},
                            {
                                text: this.$t('nav.cloud-tokens'),
                                icon: 'key',
                                to: '/administration/fob/available-cloud-fobs',
                                permissions: ['FOB_READ']
                            },
                            {
                                text: this.$t('nav.people'),
                                icon: 'people',
                                to: '/administration/people',
                                permissions: ['PERSON_READ']
                            },
                            //{
                            //    text: 'Badge Design',
                            //    icon: 'person-badge',
                            //    to: '/administration/badge-designs',
                            //    permissions: [this.isACS ? 'KMSUSER_USER' : 'SOME_PERMISSION_DOES_NOT_EVER_EXISTS']
                            //},
                            //{
                            //    text: this.$t('nav.notice-messages'),
                            //    icon: 'chat-square-text',
                            //    to: '/administration/notice-messages',
                            //    permissions: ['NOTICEMESSAGE_READ']
                            //},
                            {
                                text: this.$t('nav.door-unlock-invitation'),
                                icon: 'door-open',
                                to: '/administration/door-unlock-invitations',
                                permissions: ['DOORUNLOCKINVITATION_READ']
                            },
                            //{
                            //    text: this.$t('nav.system-summary'),
                            //    icon: 'list-check',
                            //    to: '/management/system/summary',
                            //    permissions: ['AREA_READ']
                            //},
                        
                            //{
                            //    text: this.$t('nav.system-transfer'),
                            //    icon: 'tools',
                            //    to: '/management/system/transfer',
                            //    permissions: ['CLIENT_MANAGEOWN']
                            //},
                            {
                                text: this.$t('nav.time-profiles'),
                                icon: 'clock',
                                to: '/management/time-profile-acs',
                                permissions: ['TIMEPROFILE_READ']
                            },
                            //{
                            //    text: this.$t('nav.comm-devices'),
                            //    icon: 'broadcast',
                            //    to: '/management/comm-devices',
                            //    permissions: ['COMMDEVICE_READ']
                            //},
                            //{
                            //    text: this.$t('nav.sims'),
                            //    icon: 'sim',
                            //    to: '/management/sims',
                            //    permissions: ['SIM_READ']
                            //},
                            //{
                            //    text: this.$t('nav.notice-boards'),
                            //    icon: 'easel',
                            //    to: '/management/notice-boards',
                            //    permissions: ['DIGITALNOTICEBOARD_READ']
                            //},
                            //{
                            //    text: this.$t('nav.firmware-updates'),
                            //    icon: 'box-arrow-in-down-right',
                            //    to: '/management/system/firmware-updates',
                            //    permissions: ['SYSTEM_DEBUG']
                            //},
                            //{
                            //    text: this.$t('nav.me'),
                            //    icon: 'file-person',
                            //    to: '/account',
                            //    permissions: []
                            //},
                            {
                                text: this.$t('nav.users'),
                                icon: 'person',
                                to: '/settings/users',
                                permissions: ['USER_READ']
                            },
                            //{
                            //    text: this.$t('nav.user-groups'),
                            //    icon: 'people',
                            //    to: '/settings/user-groups',
                            //    permissions: ['ROLE_READ']
                            //},
                            //{
                            //    text: this.$t('nav.hosting-contracts'),
                            //    icon: 'cash-coin',
                            //    to: '/management/hosting-contracts',
                            //    permissions: ['HOSTINGCONTRACT_READ'],
                            //},
                            {
                                text: this.$t('nav.announcements'),
                                icon: 'megaphone',
                                to: '/settings/announcement',
                                permissions: []
                            },
                            //{
                            //    text: this.$t('nav.custom-fields'),
                            //    icon: 'ui-checks',
                            //    to: '/settings/custom-fields',
                            //    permissions: ["CUSTOMFIELD_READ"]
                            //},
                            {
                                text: this.$t('nav.hardware-management'),
                                icon: 'camera-video',
                                to: '/settings/hardware-management',
                                permissions: []
                            },
                            //{
                            //    text: this.$t('nav.about'),
                            //    icon: 'info-square',
                            //    to: '/settings/about',
                            //    permissions: []
                            //}
                            {
                                text: this.$t('nav.schematic'),
                                icon: 'menu-app',
                                to: '/management/system/schematic',
                                permissions: ['COMMDEVICE_READ', 'CONTROLLER_READ', 'DOOR_READ']
                            },
                            {
                                text: this.$t('nav.stockroom'),
                                icon: 'broadcast',
                                to: '/management/stockroom',
                                permissions: ['CLIENT_MANAGEOWN']
                            },
                        ],
                    },
                    {
                        text: this.$t('nav.monitoring'),
                        icon: 'camera-video',
                        expanded: false,
                        menuItems: [
                            {
                                text: this.$t('nav.time-and-attendance'),
                                icon: 'hourglass',
                                to: '/monitoring/time-and-attendance',
                                permissions: ['PERSON_READ']
                            },
                            {
                                text: this.$t('nav.alert-people'),
                                icon: 'envelope',
                                to: '/monitoring/alert-person',
                                permissions: ['ALERTPERSON_READ']
                            },
                            {
                                text: this.$t('nav.alert-triggers'),
                                icon: 'lightning-charge',
                                to: '/monitoring/alert-trigger',
                                permissions: ['ALERTTRIGGER_READ']
                            },
                            {
                                text: this.$t('nav.reports'),
                                icon: 'file-earmark-spreadsheet',
                                to: '/monitoring/report',
                                permissions: ['EVENT_READ']
                            },
                            {
                                text: this.$t('nav.scheduled-reports'),
                                icon: 'calendar2-check',
                                to: '/monitoring/scheduled-report',
                                permissions: ['SCHEDULEDREPORT_READ']
                            },
                            
                        ],
                    },
                    {
                        text: this.$t('nav.configuration'),
                        icon: 'sliders',
                        expanded: false,
                        menuItems: [
                            {
                                text: this.$t('nav.area-types'),
                                icon: 'bookmarks',
                                to: '/configuration/area-types',
                                permissions: ['AREATYPE_READ']
                            },
                            {
                                text: this.$t('nav.features'),
                                icon: 'list-check',
                                to: '/settings/features',
                                permissions: ['FEATURE_READ']
                            },
                            {
                                text: this.$t('nav.sim-network-providers'),
                                icon: 'bar-chart',
                                to: '/configuration/sim-network-providers',
                                permissions: ['SKCONFIGURATION_READ']
                            },
                            {
                                text: this.$t('nav.sim-types'),
                                icon: 'file-earmark-spreadsheet',
                                to: '/configuration/sim-types',
                                permissions: ['SKCONFIGURATION_READ']
                            },
                            {
                                text: this.$t('nav.fob-types'),
                                icon: 'tags',
                                to: '/configuration/fob-types',
                                permissions: ['SKCONFIGURATION_READ']
                            },
                            {
                                text: this.$t('nav.fob-colours'),
                                icon: 'pentagon-half',
                                to: '/configuration/fob-colour',
                                permissions: ['SKCONFIGURATION_READ']
                            },
                            {
                                text: this.$t('nav.door-types'),
                                icon: 'door-open',
                                to: '/configuration/door-types',
                                permissions: ['SKCONFIGURATION_READ']
                            },
                            {
                                text: this.$t('nav.lock-types'),
                                icon: 'key',
                                to: '/configuration/lock-types',
                                permissions: ['SKCONFIGURATION_READ']
                            },
                            {
                                text: this.$t('nav.clients'),
                                icon: 'diagram3',
                                to: '/configuration/client',
                                permissions: ['CLIENT_READ']
                            },
                            {
                                text: `${this.$t('nav.shop')} ${this.$t('nav.orders')}`,
                                icon: 'credit-card',
                                to: '/configuration/shop-order',
                                permissions: ['SHOPORDER_UPDATE', 'SHOPORDER_APPROVE_PAYONACCOUNT'],
                            },
                            {
                                text: this.$t('nav.public-registrations'),
                                icon: 'cloud-plus',
                                to: '/configuration/public-registrations',
                                permissions: ['PUBLICREGISTRATION_READ']
                            },
                        ]
                    },
                    {
                        text: this.$t('nav.favourites'),
                        icon: 'heart',
                        expanded: false,
                        menuItems: [],
                    },
                    {
                        text: this.$t('nav.shop'),
                        icon: 'bag',
                        expanded: false,
                        menuItems: [
                            {
                                text: this.$t('nav.shop'),
                                icon: 'bag',
                                to: '/shop',
                                permissions: ['SHOPORDER_ADD'],
                            },
                            {
                                text: this.$t('nav.orders'),
                                icon: 'credit-card',
                                to: '/shop/order',
                                permissions: ['SHOPORDER_READ'],
                            },
                        ]
                    },
                    {
                        text: this.$t('nav.help'),
                        icon: 'question-circle',
                        to: 'https://help-beta.cameacs.dev?token=' + this.$auth.token(),
                        target: '_blank',
                    }
                ]
            }
        },

        computed: {
            user() {
                return this.$auth.user();
            },
            browsingClient() {
                if (!this.switchableClients.length) return null;

                var workingClientId = this.$auth.user().userData.workingClientId;
                var rtn = this.switchableClients.find(c => c.clientId == workingClientId);

                if (!rtn) return null;
                return rtn;
            }
        },

        methods: {
            subItemExpand(subItem) {
                for (var menuItem of this.menuItems) {
                    if (menuItem == subItem) menuItem.expanded = true;
                    else menuItem.expanded = false;
                }
                this.$emit('widen', subItem);
            },
            setCustomerName() {
                this.menuItems[this.$t('nav.control-panel')][this.$t('nav.control-panel')]
            },
            subItemCollapse(subItem) {
                subItem.expanded = false;
            },

            subItemWiden(subItem) {
                this.$emit('widen', subItem);
            },

            subItemNarrow(subItem) {
                this.$emit('narrow', subItem);
            },

            logoutClick: async function () {
                try {
                    this.$auth.logout({
                        makeRequest: false,
                        params: {},
                        success: () => {
                            this.$notify({ type: 'alert-success', text: 'Successfully logged out' });
                        },
                        error: (response) => this.$notify({ type: 'alert-danger', title: 'Failed to logout', text: response.data.message }),
                        redirect: '/login',
                    });
                } catch (error) {
                    this.$debugLog('Redirect error:', error)
                }
            },

            async handleUserChange() {
                var menuBrowsing = this.menuItems.find(item => item.type && item.type === 'browsing-client');
                if (!menuBrowsing) return;

                menuBrowsing.text = null;
                menuBrowsing.expanded = false;
                menuBrowsing.menuItems = null;

                if (this.user && this.user.user && this.user.user.userId) {
                    this.switchableClients = (await this.$http.get(`/user/${this.user.user.userId}/switchable-clients`)).data;

                    menuBrowsing.text = null;
                    menuBrowsing.expanded = false;
                    menuBrowsing.menuItems = [];
                } else {
                    this.switchableClients = [];
                }

                // Wait for this.browsingClient change
                
                await this.$nextTick();

                this.filterSwitchableClients();
            },
            async loadFavouriteData() {
                var menuItem = this.$t('nav.favourites');

                var favourites = (await this.$http.get(`/favourite/user-favourites`)).data;
                var favouriteLink = '/settings/user/' + this.user.user.userId + '#favourites';
                var favouriteIndex = this.menuItems.map(i => i.text).indexOf(menuItem);
                var favouriteMenuItem = this.menuItems[favouriteIndex];

                favouriteMenuItem.menuItems = [];

                favouriteMenuItem.menuItems.push({
                    text: "All Favourites",
                    icon: 'heart-fill',
                    to: favouriteLink,
                });

                for (var i = 0; i < favourites.length; i++) {
                    favouriteMenuItem.menuItems.push({
                        text: favourites[i].name,
                        icon: favourites[i].icon,
                        to: favourites[i].url,
                    });
                }

                this.$set(this.menuItems, favouriteIndex, favouriteMenuItem)

            },
            filterSwitchableClients() {
                var menuBrowsing = this.menuItems.find(item => item.type && item.type === 'browsing-client');
                if (!menuBrowsing) return;

                var filteredClients;
                if (this.switchableClientsFilter) filteredClients = this.switchableClients.filter(c =>
                    c.name.toLowerCase().indexOf(this.switchableClientsFilter.toLowerCase()) > -1 &&
                    c.clientId !== this.browsingClient.clientId
                )
                else filteredClients = this.switchableClients;

                menuBrowsing.menuItems.splice(1, menuBrowsing.menuItems.length - 1);
                Array.prototype.push.apply(menuBrowsing.menuItems, filteredClients.map(item => {
                    return {
                        type: 'switchable-client',
                        text: item.name,
                        icon: 'person',
                        clientId: item.clientId,
                    };
                }));
            },
            updateClientName() {
               var text = this.$t("nav.installers");

                if (this.user.browsingClient.isEngineer)
                    text = this.$t("nav.site-owners");

                var controlPanelMenu = this.menuItems.find(item => item.text && item.text === this.$t("nav.control-panel"));                

                var clientIndex = controlPanelMenu.menuItems.map(function (m) { return m.type }).indexOf("client");

                var updatedItem = controlPanelMenu.menuItems[clientIndex];
                updatedItem.text = text;

                this.$set(controlPanelMenu.menuItems, clientIndex, updatedItem)
                    
            }
        },

        watch: {
            async user() {
                await this.handleUserChange();
                this.updateClientName();
            },

           

            async '$store.state.favouritesEdited'(newFavouritesEdited) {
                this.loadFavouriteData();
            },

            browsingClient() {
                var menuBrowsing = this.menuItems.find(item => item.type && item.type === 'browsing-client');
                if (menuBrowsing) {
                    if (this.browsingClient) {
                        var menuFilter = {
                            type: 'switchable-client-filter',
                            text: '',
                            icon: 'search',
                        };

                        menuBrowsing.text = this.browsingClient.name;
                        menuBrowsing.expanded = false;
                        this.$set(menuBrowsing, 'menuItems', [menuFilter]);
                        this.switchableClientsFilter = this.browsingClient.name;

                        this.$watch(() => menuFilter.text, (newValue) => {
                            this.switchableClientsFilter = newValue;
                            this.filterSwitchableClients();
                        });
                    }
                }
            },
            wide() {
                if (this.wide == false) {
                    for (var menuItem of this.menuItems) {
                        menuItem.expanded = false;
                    }
                }
            }
        },

        async created() {
            await this.handleUserChange();
            await this.loadFavouriteData();
            this.updateClientName();

            var menuBrowsing = this.menuItems.find(item => item.type && item.type === 'browsing-client');
            if (menuBrowsing) {
                if (this.$auth.check('CLIENT_READ', 'permissions')) {
                    // Populate the browsing client menu
                    var menuFilter = menuBrowsing.menuItems.find(item => item.type && item.type === 'switchable-client-filter');
                    if (menuFilter) {
                        this.$watch(() => menuFilter.text, (newValue) => {
                            this.switchableClientsFilter = newValue;
                            this.filterSwitchableClients();
                        });
                    }
                } else {
                    // Remove browsing client menu from the side bar
                    var menuBrowsingIndex = this.menuItems.indexOf(menuBrowsing);
                    this.menuItems.splice(menuBrowsingIndex, 1);
                }
            }
        },
    }


</script>

<style scoped>

    .came {
        font-family: 'came_type';
        font-weight: 400;
        font-size: 2.75rem;
        line-height: 1;
    }

    .dropup .dropdown-toggle::after {
        display: none;
    }

  
</style>